export default "__VITE_ASSET__Dc2m$tNj__"